module.exports = __webpack_public_path__ + "static/media/homeitem4.06ba8951.png";